// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"2eb14d7f","299":"2eb14d7f","864":"1994f232"}[chunkId] + ".chunk.css";
};